<template>
  <Teleport to="body">
    <div class="toast-container">
      <Toast
        v-for="toast in toasts"
        :key="toast.id"
        :message="toast.message"
        :type="toast.type"
        :duration="toast.duration"
        :closable="toast.closable"
        @close="removeToast(toast.id)"
      />
    </div>
  </Teleport>
</template>

<script>
import Toast from './Toast.vue';

export default {
  name: 'ToastContainer',
  components: {
    Toast
  },
  data() {
    return {
      toasts: []
    };
  },
  methods: {
    addToast(message, type = 'info', duration = 4000, closable = true) {
      const id = Date.now() + Math.random();
      this.toasts.push({
        id,
        message,
        type,
        duration,
        closable
      });
      return id;
    },
    removeToast(id) {
      const index = this.toasts.findIndex(t => t.id === id);
      if (index > -1) {
        this.toasts.splice(index, 1);
      }
    },
    success(message, duration = 4000) {
      return this.addToast(message, 'success', duration);
    },
    error(message, duration = 5000) {
      return this.addToast(message, 'error', duration);
    },
    warning(message, duration = 4000) {
      return this.addToast(message, 'warning', duration);
    },
    info(message, duration = 4000) {
      return this.addToast(message, 'info', duration);
    },
    clear() {
      this.toasts = [];
    }
  },
  mounted() {
    // Make toast methods available globally
    if (!this.$root.$toast) {
      this.$root.$toast = {
        success: (message, duration) => this.success(message, duration),
        error: (message, duration) => this.error(message, duration),
        warning: (message, duration) => this.warning(message, duration),
        info: (message, duration) => this.info(message, duration),
        clear: () => this.clear()
      };
    }
  }
};
</script>

<style src="./styles/ToastContainer.css"></style>

